import { mapSceneElementIdsToElements } from '../../../../shared/helpers/scenesHelpers';

export const getEndTimes = stageElements => {
  const elementLengthsInMs = stageElements.reduce((acc, element) => {
    const prevElementTime = acc[acc.length - 1] || 0;
    acc.push(element.animationTime + element.pauseTime + prevElementTime);
    return acc;
  }, []);
  return elementLengthsInMs;
};

export function getElementAnimationTimeMs(element, scribe) {
  const time = typeof element.animationTime === 'undefined' ? scribe.settings.animationTime : element.animationTime;
  if (typeof time === 'undefined') {
    return 0;
  }
  return time * 1000;
}

export function getElementPauseTimeMs(element, scribe) {
  const time = typeof element.pauseTime === 'undefined' ? scribe.settings.pauseTime : element.pauseTime;
  if (typeof time === 'undefined') {
    return 0;
  }
  return time * 1000;
}

export function getElementTotalTimesLengthMs(element, scribe) {
  return getElementPauseTimeMs(element, scribe) + getElementAnimationTimeMs(element, scribe);
}

export function getStartTime(scribe, elementId) {
  if (!elementId) {
    return 0;
  }

  const allElements = scribe.scenes.flatMap(scene => {
    const { settings } = scene;
    return mapSceneElementIdsToElements(scribe, scene).map(element => ({
      ...element,
      animationTime: element.animationTime !== undefined ? element.animationTime : settings.animationTime,
      pauseTime: element.pauseTime !== undefined ? element.pauseTime : settings.pauseTime
    }));
  });

  const index = allElements.findIndex(el => el.id === elementId);
  if (index === -1) {
    return 0;
  }

  const elements = allElements.slice(0, index);
  const startTime = elements.reduce((prevTime, el) => {
    return prevTime + getElementAnimationTimeMs(el, scribe) + getElementPauseTimeMs(el, scribe);
  }, 0);
  return startTime;
}

export function getSceneStartEndTimes(scribe, scene, sceneIndex) {
  const sceneStartTime = scribe.scenes
    .slice(0, sceneIndex)
    .flatMap(s => s.elementIds)
    .map(elId => scribe.elements.find(el => el.id === elId))
    .reduce((prevTime, e) => {
      return prevTime + getElementAnimationTimeMs(e, scribe) + getElementPauseTimeMs(e, scribe);
    }, 0);

  const sceneLength = mapSceneElementIdsToElements(scribe, scene).reduce((prevTime, e) => {
    return prevTime + getElementAnimationTimeMs(e, scribe) + getElementPauseTimeMs(e, scribe);
  }, 0);

  const sceneEndTime = sceneStartTime + sceneLength;

  return {
    startTime: sceneStartTime,
    endTime: sceneEndTime
  };
}
